import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Select as AntdSelect } from 'antd';

import { View } from '../View';
import Text from '../Text';

import { styleUtils } from '../../utils';

import styles from './styles';
import {AngleDown} from "../../../assets/icons";
import {COLORS} from "../../design/tokens";

const { Option } = AntdSelect;
const { style } = styleUtils;
const IconContainer = style('span', styles.iconContainer);
const Container = style(View, styles.container);
const SSelect = style(AntdSelect, styles.select);
const SMessage = style(Text, styles.message);
const Label = style(Text, styles.label);
const Icon = (
  <AngleDown
    viewBox="8 13 25 15"
    fill={COLORS.TEXT.LIGHT_GRAY}
    width={18}
    height={15}
  />
);

class Select extends PureComponent {
  render() {
    const {
      options,
      label,
      required,
      defaultValue,
      placeholder,
      onChange,
      error,
      message,
      ...restOfProps
    } = this.props;
    return (
      <Container>
        {label && (
          <Label weight="900" required={required}>
            {label}
          </Label>
        )}
        <SSelect
          size="large"
          disabled={this.props.disabled}
          defaultValue={defaultValue}
          onChange={onChange}
          placeholder={placeholder}
          suffixIcon={Icon}
          error={error}
          {...restOfProps}
          name={restOfProps.name}
          dropdownStyle={{ fontSize: '16px' }}
        >
          {
            options.map(({ value, label: Label, icon: Icon, disabled = false }) => (
            <Option key={value} disabled={disabled} value={value}>
              {Icon && <IconContainer><Icon /></IconContainer>}
              <Text>{typeof Label === 'string' ? Label : <Label/>}</Text>
            </Option>
          ))}
        </SSelect>
        <Message message={message} error={error} />
      </Container>
    );
  }
}

const Message = ({ message, error }) =>
  message ? (
    <SMessage error={error} size="small">
      {message}
    </SMessage>
  ) : null;

Select.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.any.isRequired,
      disabled: PropTypes.bool
    })
  ).isRequired,
  label: PropTypes.string,
  required: PropTypes.bool,
  defaultValue: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  error: PropTypes.bool,
  message: PropTypes.string,
  disabled: PropTypes.bool
};

Select.defaultProps = {
  disabled: false,
  placeholder: null,
  error: false
};

export default Select;
